<template>
  <div>
      <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            Email
          </label>
          <input type="email"
                 name="email"
                 v-validate="{'required': true}"
                 v-model="model.email"
                 ref="email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
      </div>
    </div>
      <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            Email repeat
          </label>
          <input type="email_repeat"
                 name="email_repeat"
                 v-validate="'required|confirmed:email'"
                 v-model="email_repeat"
                 class="form-control">
          <small class="text-danger" v-show="errors.has('email_repeat')">
            Email must match
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            First Name
          </label>
          <input class="form-control"
                 type="text"
                 name="first_name"
                 v-validate="'required|min:4'"
                 v-model="model.first_name"
                 placeholder="ex: Mike"
          />
          <small class="text-danger" v-show="first_name.invalid">
            {{ getError('first_name') }}
          </small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            Last Name
          </label>
          <input class="form-control"
                 type="text"
                 name="last_name"
                 v-validate="'required|min:2'"
                 v-model="model.last_name"
                 placeholder="ex: Andrew"
          />
          <small class="text-danger" v-show="last_name.invalid">
            {{ getError('last_name') }}
          </small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            Address line 1
          </label>
          <input class="form-control"
                 type="text"
                 name="address_1"
                 v-validate="'required|min:4'"
                 v-model="model.address_1"
                 placeholder="ex: Kennedy Road 1"
          />
          <small class="text-danger" v-show="address_1.invalid">
            {{ getError('address_1') }}
          </small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            Address line 2
          </label>
          <input class="form-control"
                 type="text"
                 name="address_2"
                 v-model="model.address_2"
                 placeholder="ex: Suit 1 or Appartment 2"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            ZIP code
          </label>
          <input class="form-control"
                 type="text"
                 name="zipcode"
                 v-model="model.zipcode"
                 placeholder="ex: 12345"
          />
          <small class="text-danger" v-show="zipcode.invalid">
            {{ getError('zipcode') }}
          </small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            City
          </label>
          <input class="form-control"
                 type="text"
                 name="city"
                 v-model="model.city"
                 placeholder="ex: New York"
          />
          <small class="text-danger" v-show="city.invalid">
            {{ getError('city') }}
          </small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            State
          </label>
          <input class="form-control"
                 type="text"
                 name="state"
                 v-model="model.state"
                 placeholder="ex: Arizona"
          />
          <small class="text-danger" v-show="state.invalid">
            {{ getError('state') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    computed: {
      ...mapFields(['first_name', 'last_name', 'email', 'address_1', 'zipcode', 'city', 'state'])
    },
    data () {
      return {
        model: {
          first_name: '',
          last_name: '',
          email: '',
          address_1: '',
          address_2: '',
          zipcode: '',
          city: '',
          state: '',
        },
        email_repeat: ''
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register/FirstStep.vue